import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import RateInput from '../common/RateInput';
import SelectInputWithSymbol from '../common/SelectInputWithSymbol/SelectInputWithSymbol';
import { putRequest } from '../../requestUtils';
import dollarImage from '../../../assets/images/icons/dollar.svg';
import './EditInvoiceRate.scss';
var EditInvoiceRate = /*#__PURE__*/function (_Component) {
  function EditInvoiceRate(props) {
    var _this;
    _classCallCheck(this, EditInvoiceRate);
    _this = _callSuper(this, EditInvoiceRate, [props]);
    _this.state = {
      netRate: props.net_rate,
      travelRate: props.travel_rate,
      grossRate: props.gross_rate,
      grossTravelRate: props.gross_travel_rate,
      hourLimit: props.hourLimit,
      takeRate: Math.round(props.takeRate * 100) / 100,
      updateProposalRate: true,
      quickbooksPaymentTerm: props.quickbooksPaymentTerm
    };
    _this.handleUpdateProposal = _this.handleUpdateProposal.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.updateTakeRate = _this.updateTakeRate.bind(_this);
    return _this;
  }
  _inherits(EditInvoiceRate, _Component);
  return _createClass(EditInvoiceRate, [{
    key: "handleUpdateProposal",
    value: function handleUpdateProposal() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        putUrl = _this$props.putUrl;
      var _this$state = this.state,
        netRate = _this$state.netRate,
        travelRate = _this$state.travelRate,
        grossRate = _this$state.grossRate,
        grossTravelRate = _this$state.grossTravelRate,
        hourLimit = _this$state.hourLimit,
        takeRate = _this$state.takeRate,
        updateProposalRate = _this$state.updateProposalRate,
        quickbooksPaymentTerm = _this$state.quickbooksPaymentTerm;
      var rates = {
        net_rate: netRate * 100,
        travel_rate: travelRate * 100,
        gross_rate: grossRate * 100,
        gross_travel_rate: grossTravelRate * 100
      };
      putRequest(putUrl, {
        rates: rates,
        hour_limit: hourLimit,
        clora_take_rate: takeRate,
        update_proposal_rate: updateProposalRate,
        quickbooks_payment_term: quickbooksPaymentTerm
      }, csrfToken).then(function () {
        return window.location.reload();
      });
    }
  }, {
    key: "calculatedTakeRate",
    value: function calculatedTakeRate() {
      var _this$state2 = this.state,
        netRate = _this$state2.netRate,
        grossRate = _this$state2.grossRate;
      var rawRate = 1.0 - netRate / grossRate;
      return Math.round(rawRate * 10000) / 100;
    }
  }, {
    key: "updateTakeRate",
    value: function updateTakeRate() {
      if (isNaN(this.calculatedTakeRate()) || this.calculatedTakeRate() < 0) return;
      this.setState({
        takeRate: this.calculatedTakeRate()
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(rate, key) {
      this.setState(_defineProperty({}, key, rate), this.updateTakeRate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        isEditingProposal = _this$props2.isEditingProposal,
        quickbooksPaymentTermOptions = _this$props2.quickbooksPaymentTermOptions;
      var _this$state3 = this.state,
        netRate = _this$state3.netRate,
        travelRate = _this$state3.travelRate,
        grossRate = _this$state3.grossRate,
        grossTravelRate = _this$state3.grossTravelRate,
        updateProposalRate = _this$state3.updateProposalRate,
        hourLimit = _this$state3.hourLimit,
        takeRate = _this$state3.takeRate,
        quickbooksPaymentTerm = _this$state3.quickbooksPaymentTerm;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: isEditingProposal ? 'Edit Rates' : 'Edit Rates or Hour Limit',
        submitButtonText: "Yes, Update Rates",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleUpdateProposal,
        buttonStyles: isEditingProposal ? 'btn btn-default' : '',
        triggerType: isEditingProposal ? 'button' : 'link',
        idKey: "edit-invoice-rate-modal",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-4"
      }, "Do you want to edit the hourly rate, take rate, or hour limit?"), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Employer Hourly Rate (Gross):"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "gross-rate",
        value: grossRate,
        containerClass: "mt-3 me-2",
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'grossRate');
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }, "/ hour"))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Consultant Hourly Rate (Net)"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "net-rate",
        value: netRate,
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'netRate');
        },
        placeholder: "Net Hourly Rate"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pr-5",
        src: dollarImage,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }, "/ hour"))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Employer Travel Rate (Gross):"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "gross-travel-rate",
        value: grossTravelRate,
        containerClass: "mt-2 me-1",
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'grossTravelRate');
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }, "/ hour"))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Consultant Travel Rate (Net):"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "travel-rate",
        value: travelRate,
        containerClass: "mt-2 me-1",
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'travelRate');
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-2",
        src: dollarImage,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }, "/ hour"))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Hour Limit:"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "hour-limit",
        value: hourLimit,
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleChange(val, 'hourLimit');
        },
        containerClass: "mt-2 me-1",
        placeholder: "Max Hours"
      }, /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-clock muted-gray-text pe-2"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-1 rate-label"
      }, "Take Rate:"), /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement(RateInput, {
        id: "take-rate",
        key: takeRate,
        value: takeRate,
        placeholder: "Clora's Percentage",
        containerClass: "mt-2 me-1",
        allowDecimals: true,
        onAnswerChange: function onAnswerChange() {},
        readOnly: true
      }, /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon pe-2"
      }, "%")), /*#__PURE__*/React.createElement("div", {
        className: "per-hour"
      }))), /*#__PURE__*/React.createElement(SelectInputWithSymbol, {
        label: /*#__PURE__*/React.createElement("div", {
          className: "input-label",
          style: {
            color: '#424242',
            fontFamily: 'avenirnext-medium'
          }
        }, "Quickbooks Payment Term"),
        placeholder: "Quickbooks Payment Term",
        inputName: "quickbooksPaymentTerm",
        onChange: function onChange(e) {
          return _this2.handleChange(e.value, 'quickbooksPaymentTerm');
        },
        errors: "",
        containerWidth: "80%",
        value: {
          value: quickbooksPaymentTerm,
          label: quickbooksPaymentTerm
        },
        options: quickbooksPaymentTermOptions
      }), !isEditingProposal && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("label", {
        className: "me-5",
        htmlFor: "future"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "future",
        name: "future",
        checked: updateProposalRate === true,
        onChange: function onChange() {
          return _this2.handleChange(true, 'updateProposalRate');
        }
      }), "Update current and next timesheets"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "current"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "current",
        name: "current",
        checked: updateProposalRate === false,
        onChange: function onChange() {
          return _this2.handleChange(false, 'updateProposalRate');
        }
      }), "Update current timesheet"))));
    }
  }]);
}(Component);
EditInvoiceRate.propTypes = {
  net_rate: PropTypes.number.isRequired,
  travel_rate: PropTypes.number.isRequired,
  gross_rate: PropTypes.number,
  gross_travel_rate: PropTypes.number,
  hourLimit: PropTypes.number,
  takeRate: PropTypes.number,
  csrfToken: PropTypes.string.isRequired,
  putUrl: PropTypes.string.isRequired,
  isEditingProposal: PropTypes.bool,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }))
};
EditInvoiceRate.defaultProps = {
  gross_rate: null,
  gross_travel_rate: null,
  hourLimit: null,
  takeRate: 20,
  isEditingProposal: false,
  quickbooksPaymentTermOptions: []
};
export default EditInvoiceRate;